var map = {
	"./Accordion.svg": 531,
	"./Breadcrumb.svg": 532,
	"./Button.svg": 533,
	"./Checkbox.svg": 534,
	"./Code snippet.svg": 535,
	"./Content switcher.svg": 536,
	"./Data table.svg": 537,
	"./Date picker.svg": 538,
	"./Dropdown.svg": 539,
	"./File uploader.svg": 540,
	"./Form.svg": 541,
	"./Inline loading.svg": 542,
	"./Link.svg": 543,
	"./List.svg": 544,
	"./Loading.svg": 545,
	"./Modal.svg": 546,
	"./Multiselect.svg": 547,
	"./NoImage.svg": 327,
	"./Notification.svg": 548,
	"./Number input.svg": 549,
	"./Overflow menu.svg": 550,
	"./Pagination.svg": 551,
	"./Progress indicator.svg": 552,
	"./Radio button.svg": 553,
	"./Search.svg": 554,
	"./Select.svg": 555,
	"./Slider.svg": 556,
	"./Structured list.svg": 557,
	"./Tabs.svg": 558,
	"./Tag.svg": 559,
	"./Text input.svg": 560,
	"./Tile.svg": 561,
	"./Toggle.svg": 562,
	"./Tooltip.svg": 563,
	"./UI shell.svg": 564
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 530;